import { render, staticRenderFns } from "./FinalReceipt.vue?vue&type=template&id=68174b0c&"
import script from "./FinalReceipt.vue?vue&type=script&lang=js&"
export * from "./FinalReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports